import {
    takeLatest,
    call,
    put, take, all, select, fork
} from 'redux-saga/effects';
import { RETRIEVED_BRAND_CONFIG, RETRIEVED_FACEPLATE_GROUPS } from 'capi/redux';
import { Set as ISet } from 'immutable';
import { logError } from '../utils/errorUtils';

import {
    APP_ERROR_TYPES,
    changeStorefrontFlow,
    SHOW_APP_ERROR,
    ROUTE_CHANGED
} from './routingModule';
import { PAYMENT_SUCCESS, PAYMENT_FAILED, PRE_AUTH_REJECTED } from '../payment/paymentModule';
import { removeQueryParams, replace } from './routing';
import { getErrorNoRetryPath } from './paths';
import {
    PAYMENT,
    PDP_STEP,
    REDIRECTION_ORDER_STEP
} from './flowConstants';
import { getFlowContextMethodsForSaga } from './FlowProvider';
import {
    getIsOldUiPreferred,
    getIsSmartflow,
    getPreferredValues as getUnvalidatedPreferredValues, isGSAEnabled,
    getRealtimeRiskPagesEnableBrand
} from '../app/bootstrap';
import { handleRemoveBuyNowItem } from '../productCartHandler/productCartModule';
import {
    HANDLE_PREFFERED_VALUES,
    flowStateInitialized,
    setPreferredValue,
    updateFlowProgress,
    setPreferredPaymentValue,
    PREFERRED_CLASSIC_GIFT,
    PREFERRED_FACEPLATE_CATEGORY,
    preferredValueHandled
} from './flowProgressModule';

import {
    hasClassicCatalogs as getHasClassicCatalogs,
    getLoyaltyProgramValidator,
    getBrandSupportedCardTypes
} from '../brand/brandSelectors';

import {
    AMOUNT_FIELD,
    RECIPIENT_NAME_FIELD,
    SENDER_NAME_FIELD,
    RECIPIENT_EMAIL_FIELD,
    IS_PLASTIC_FIELD,
    FACEPLATE_FIELD,
    IS_SELFBUY_FIELD,
    CURRENCY_FIELD,
    MESSAGE_FIELD, SENDER_EMAIL, LOYALTY_FIELD,
    CARD_TYPES as CARD_TYPE, SENDER_EMAIL_FIELD, AUTH_REASON_CODE
} from '../constants/constants';

import {
    validateName,
    validateEmail,
    validateAmount,
    validateCardType,
    validateBillingFirstName,
    validateBillingLastName,
    validateLoyaltyNumber,
    validateSelfBuy,
    validateClassicGift,
    validateMessage,
    validateFaceplateCategory
} from './preferredValuesValidators';
import { formatAmountToString } from '../utils/numberUtils';
import alphaNumericNormalizer from '../addressFields/validate/alphaNumericNormalizer';
import { validatePreferredCurrencyCode, validatePreferredFaceplateCode } from '../landingPage/landingPageSagas';
import { ADDRESS_FIRSTNAME, ADDRESS_LASTNAME } from '../address/addressModule';


export function* showAppError({ errorType }) {
    if (errorType === APP_ERROR_TYPES.NO_RETRY) {
        yield call(replace, { pathname: getErrorNoRetryPath() });
    }
}



const PAYMENT_PROVIDER_PARAMS = [
    'decision', 'authorizationId', 'caseId',
    'approvedAmount', 'paymentMethod', 'signature', 'captureId'
];

export function* completeBuyFlow({ orderDetails }) {
    const { goToNextStep } = yield call(getFlowContextMethodsForSaga);
    
    yield call(removeQueryParams, PAYMENT_PROVIDER_PARAMS);
        const location = {
        state: orderDetails
    };

    const isRealtimeRiskEnabled = getRealtimeRiskPagesEnableBrand();
    const lastAuthReasonCode = orderDetails?.lastAuthReasonCode;
    const isRiskReasonCode = lastAuthReasonCode === AUTH_REASON_CODE.RISK_REJECTED
        || lastAuthReasonCode === AUTH_REASON_CODE.RISK_REVIEW;

    
    
    
    
    
    
    
    if (lastAuthReasonCode === AUTH_REASON_CODE.RISK_REJECTED && isRealtimeRiskEnabled) {
        yield call(goToNextStep, PAYMENT, {
            shouldPushHistory: false,
            isCancellation: true,
            overwritingHistoryParams: { ...location }
        });
        return;
    }

    
    
    const effectiveLocation = !isRealtimeRiskEnabled && isRiskReasonCode
        ? { state: { ...(orderDetails ?? {}), lastAuthReasonCode: null } }
        : location;

    yield call(
        goToNextStep,
        PAYMENT,
        {
            shouldPushHistory: false,
            paymentSuccess: true,
            overwritingHistoryParams: { ...effectiveLocation }
        }
    );
}


export function* orderFailureHandler() {
    const newUiEnabled = !getIsOldUiPreferred();
    yield call(removeQueryParams, PAYMENT_PROVIDER_PARAMS);

    if (!newUiEnabled) {
        const { goToNextStep } = yield call(getFlowContextMethodsForSaga);
        yield call(goToNextStep, PAYMENT, { shouldPushHistory: false });
    }
}

export function* initializeStorefrontBuyFlow() {
    
    yield put(changeStorefrontFlow());
    
    yield put(handleRemoveBuyNowItem());
}

export function* routeChanged({ stepName }) {
    const EXCLUDED_STEPS = [PAYMENT, PDP_STEP, REDIRECTION_ORDER_STEP];
    if (!EXCLUDED_STEPS.includes(stepName)) {
                yield call(initializeStorefrontBuyFlow);
    }
}

export function* isSmartflow() {
    const isItSmartflow = yield call(getIsSmartflow);
    if (isItSmartflow) {
        yield put(setPreferredValue('isSmartFlow', true));
    }
}


function* handlePreferredValueWithoutSkip(
    isPaymentValue,
    storeKey,
    processedPreferredValue,
    skipUpdateProgress,
    onUpdate
) {
    if (isPaymentValue) {
        
        yield put(setPreferredPaymentValue(storeKey, processedPreferredValue));
    } else {
        
        yield put(setPreferredValue(storeKey, processedPreferredValue));
    }

    if (!skipUpdateProgress) {
        yield put(updateFlowProgress(ISet([storeKey])));
    }

    if (onUpdate) {
        yield call(onUpdate, processedPreferredValue);
    }
}


function* handlePreferredValue(preferredValue = null, options) {
    const {
        storeKey,
        validator,
        formatter,
        onUpdate,
        isPaymentValue,
        skipUpdateProgress
    } = options;
    let isPreferredValueSkipped = true;
    let processedPreferredValue = preferredValue;

    
    if (processedPreferredValue !== null && validator) {
        processedPreferredValue = yield call(validator, preferredValue);
    }

    
    if (processedPreferredValue !== null && formatter) {
        processedPreferredValue = yield call(formatter, processedPreferredValue);
    }

    
    if (processedPreferredValue !== null) {
        
        yield* handlePreferredValueWithoutSkip(
            isPaymentValue,
            storeKey,
            processedPreferredValue,
            skipUpdateProgress,
            onUpdate
        );
        
        isPreferredValueSkipped = false;
    }
    yield put(preferredValueHandled(storeKey, isPreferredValueSkipped));
}

export function* initializeFlow() {
    
    

    
    
    const actionsToAwait = {
        catalog: take(RETRIEVED_BRAND_CONFIG.CATALOG),
        preferences: take(RETRIEVED_BRAND_CONFIG.PREFERENCES),
        faceplates: take(RETRIEVED_FACEPLATE_GROUPS)
    };

    try {
        yield all(actionsToAwait);

        const preferredValues = yield call(getUnvalidatedPreferredValues);

        
        const selfBuyEnabled = true;
        const hasClassicCatalogs = yield select(getHasClassicCatalogs);
        const brandSupportedCardTypes = yield select(getBrandSupportedCardTypes);
        const loyaltyNumberRegex = yield select(getLoyaltyProgramValidator);

        
                const preferredValuesOptions = {
            currencyCode: {
                storeKey: CURRENCY_FIELD,
                onUpdate: function* onUpdate() {
                    
                    if (!isGSAEnabled()) {
                        yield call(removeQueryParams, ['currencyCode', 'currency_code']);
                    }
                },
                validator: preferredValue => validatePreferredCurrencyCode(preferredValue),
                formatter: preferredValue => preferredValue.toUpperCase()
            },
            recipientName: {
                storeKey: RECIPIENT_NAME_FIELD,
                validator: validateName
            },
            senderName: {
                storeKey: SENDER_NAME_FIELD,
                validator: validateName
            },
            recipientEmail: {
                storeKey: RECIPIENT_EMAIL_FIELD,
                validator: validateEmail
            },
            senderEmail: {
                storeKey: SENDER_EMAIL_FIELD,
                validator: validateEmail
            },
            amount: {
                storeKey: AMOUNT_FIELD,
                validator: validateAmount,
                formatter: formatAmountToString
            },
            cardType: {
                storeKey: IS_PLASTIC_FIELD,
                
                
                validator: preferredValue => validateCardType(preferredValue.toLowerCase(), brandSupportedCardTypes),
                formatter: preferredValue => preferredValue.toLowerCase() === CARD_TYPE.Physical.toLowerCase()
            },
            faceplateCategory: {
                storeKey: PREFERRED_FACEPLATE_CATEGORY,
                validator: validateFaceplateCategory,
                formatter: preferredValue => alphaNumericNormalizer(preferredValue).toLowerCase()
            },
            faceplateCode: {
                storeKey: FACEPLATE_FIELD,
                validator: validatePreferredFaceplateCode
            },
            selfBuy: {
                storeKey: IS_SELFBUY_FIELD,
                validator: preferredValue => validateSelfBuy(preferredValue, selfBuyEnabled)
            },
            classicGift: {
                storeKey: PREFERRED_CLASSIC_GIFT,
                validator: preferredValue => validateClassicGift(preferredValue, hasClassicCatalogs)
            },
            billingFirstName: {
                storeKey: ADDRESS_FIRSTNAME,
                validator: validateBillingFirstName,
                isPaymentValue: true,
                skipUpdateProgress: true
            },
            billingLastName: {
                storeKey: ADDRESS_LASTNAME,
                validator: validateBillingLastName,
                isPaymentValue: true,
                skipUpdateProgress: true
            },
            billingPurchaserEmail: {
                storeKey: SENDER_EMAIL,
                validator: validateEmail,
                isPaymentValue: true,
                skipUpdateProgress: true
            },
            loyaltyNumber: {
                storeKey: LOYALTY_FIELD,
                validator: preferredValue => validateLoyaltyNumber(loyaltyNumberRegex, preferredValue),
                isPaymentValue: true,
                skipUpdateProgress: true
            },
            message: {
                storeKey: MESSAGE_FIELD,
                validator: validateMessage,
                onUpdate: function* onUpdate() {
                    yield call(removeQueryParams, ['message']);
                }
            }
        };

        const preferredValuesHandlers = [];
        
        
        for (const [fieldName, options] of Object.entries(preferredValuesOptions)) {
            const preferredValue = preferredValues[fieldName];

            
            if (typeof preferredValue !== 'undefined' && preferredValue !== null) {
                preferredValuesHandlers.push(yield fork(handlePreferredValue, preferredValue, options));
            } else {
                yield put(preferredValueHandled(options.storeKey, true));
            }
        }
        yield Promise.all(preferredValuesHandlers);
    } catch (error) {
        logError(`There was an error in initializeFlow: ${error}`);
    } finally {
        
        
        yield put(flowStateInitialized());
    }
}





export function* preAuthRejectedHandler({ reasonCode }) {
    try {
        yield call(removeQueryParams, PAYMENT_PROVIDER_PARAMS);

        
        if (!getRealtimeRiskPagesEnableBrand()) {
            return;
        }

        const { goToNextStep } = yield call(getFlowContextMethodsForSaga);
        yield call(goToNextStep, PAYMENT, {
            shouldPushHistory: false,
            isCancellation: true,
            overwritingHistoryParams: {
                state: {
                    lastAuthReasonCode: reasonCode
                }
            }
        });
    } catch (error) {
        logError(`Failed to navigate to cancellation page after pre-auth rejection: ${error}`);
        yield put({ type: PAYMENT_FAILED });
    }
}

export function* flowSagasWatcher() {
    yield takeLatest(SHOW_APP_ERROR, showAppError);
    yield takeLatest(PAYMENT_SUCCESS, completeBuyFlow);
    yield takeLatest(PAYMENT_FAILED, orderFailureHandler);
    yield takeLatest(PRE_AUTH_REJECTED, preAuthRejectedHandler);
    yield takeLatest(ROUTE_CHANGED, routeChanged);
    yield takeLatest(HANDLE_PREFFERED_VALUES, initializeFlow);
    yield takeLatest(HANDLE_PREFFERED_VALUES, isSmartflow);
}
